export const MEAL_CARD_PRICE_EXPERIMENT = 'meal-card-price-experiment'
export const NEW_PICTURES_SEATTLE_EXPERIMENT = 'new-pictures-seattle-experiment'

export const FIVE_MILESTONE_CHALLENGE_EXPERIMENT = {
  name: 'FIVE_MILESTONE_CHALLENGE',
  experiment: {
    id: 'gtt-4143',
    name: 'Growth - Activation - 5 Milestones Challenge'
  },
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const THREE_ORDERS_CHALLENGE_EXPERIMENT = {
  name: 'THREE_ORDERS_IN_THIRTY_DAYS',
  experiment: {
    id: 'gro-sc-4762',
    name: 'Growth - Activation - 3 Orders Challenge'
  },
  variantsMap: {
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const UNSKIP_WHEN_IS_PAUSED = {
  name: 'UNSKIP_WHEN_IS_PAUSED',
  experiment: {
    id: 'gtt-4676',
    name: 'Growth - Activation - Unskip when Paused'
  },
  variantsMap: {
    disabled: 'disabled',
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const ADD_AND_SAVE_BANNER = {
  name: 'ADD_AND_SAVE_BANNER',
  experiment: {
    id: 'gtt-5038',
    name: 'Growth - Activation - Add&Save Ribbon'
  },
  variantsMap: {
    disabled: 'disabled',
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const MYO_UPDATES = {
  name: 'MYO_UPDATES',
  experiment: {
    id: 'gtt-5206',
    name: 'Growth - Activation - New MYO with skip more visible'
  },
  variantsMap: {
    disabled: 'disabled',
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const ADD_AND_SAVE_MENU_BANNER = {
  name: 'ADD_AND_SAVE_MENU_BANNER',
  experiment: {
    id: 'cos-8420',
    name: 'Chef Marketing - Menu Scroll-Down Add&Save Banner'
  },
  variantsMap: {
    disabled: 'disabled',
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const TRIVIA_DISCOUNT_CARD = {
  name: 'CMK_ENABLE_TRIVIA_COUPON_IN_CONFIRMATION',
  experiment: {
    id: 'trivia-discount-coupon-card',
    name: 'Chef Marketing - Trivia Discount Coupon Card'
  },
  variantsMap: {
    disabled: 'disabled',
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const ADD_AND_SAVE_RIBBON_EXPERIMENT = {
  name: 'ADD_AND_SAVE_RIBBON_EXPERIMENT',
  experiment: {
    id: 'add-and-save-cart-ribbon-experiment',
    name: 'Chef Marketing - Add & Save Cart Ribbon'
  },
  variantsMap: {
    disabled: 'disabled',
    control: 'control',
    treatment1: 'treatment-1'
  }
}

export const BFF_USER_RATING = {
  name: 'bff-user-rating',
  experiment: {
    id: 'MAR-8235',
    name: 'PZN - Display User Rating'
  },
  variantsMap: {
    disabled: 'disabled',
    control: 'control',
    treatment1: 'treatment-1'
  }
}
